module.exports = __webpack_public_path__ + "static/media/wallet.23cbfa87.png";